<template>
  <div id="app">
    <template v-if="$route.meta.isWord">
      <router-view />
    </template>
    <template v-else>
      <webHead></webHead>
      <router-view />
      <webFooter></webFooter>
    </template>
  </div>
</template>
<script>
import webHead from '@/components/Common/header.vue';
import webFooter from '@/components/Common/footer.vue';
import { addKeyboardKey, removeKeyboardKey } from '@/utils/keyboard';
export default {
  components: {
    webHead, webFooter
  },
  data () {
    return {}
  },

  mounted () {
    // this.listenCode()
  },
  methods: {
    //获取登录状态公共变量
    Getloginstatus () {
      let loginstatus = localStorage.getItem("LGSTATUS");
      if (loginstatus == "" || loginstatus == undefined) {
        loginstatus = false;
        localStorage.setItem("LGSTATUS", false);
      }
      // this.$store.commit("logined",loginstatus);
    },
    listenCode () {
      // 添加监听
      window.addEventListener('keydown', addKeyboardKey)
      window.addEventListener('keyup', removeKeyboardKey)
      this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('keydown', addKeyboardKey)
        window.removeEventListener('keyup', removeKeyboardKey)
      })
    }
  }
}
</script>

<style lang="scss">
/* 临时在线iconFont引入 上线后需要删除 */
// @import url('//at.alicdn.com/t/c/font_3841373_zasnmfhggvr.css');
</style>
